module.exports = __webpack_public_path__ + "img/sanctuary.77be7d42.png";